import type { QueryUserBillingInfoResponse } from '@/hooks/query/useQueryUserBillingInfo';
import { SubscriptionTier } from '@heidi/schema/ml-scribe';

function hasSelfServeStripeSubscription(
  billingInfo: QueryUserBillingInfoResponse,
  currentPlan: SubscriptionTier
): boolean {
  if (currentPlan === SubscriptionTier.EVIDENCE) {
    return Boolean(billingInfo.evidence_billing?.stripe_subscription_id);
  }
  return Boolean(billingInfo.stripe_subscription_id);
}

/** Paid self-serve subscriber cancelled at period end: no next bill date, still active until period ends. */
export function isCancelPendingSubscription(
  billingInfo: QueryUserBillingInfoResponse | undefined,
  isTrialing: boolean
): boolean {
  if (billingInfo == null || isTrialing) {
    return false;
  }
  const currentPlan = billingInfo.new_product_tier;
  if (
    currentPlan == null ||
    currentPlan === SubscriptionTier.FREE ||
    billingInfo.next_billing_date
  ) {
    return false;
  }
  return hasSelfServeStripeSubscription(billingInfo, currentPlan);
}
